import { graphql } from '@generated/gql';

export const FETCH_ACCOUNT_SUBACCOUNTS = graphql(/** GraphQL */ `
  query fetchAccountSubAccounts($accountId: SafeString!) {
    fetchAccount(input: { accountId: $accountId }) {
      account {
        subAccounts {
          id
          goal {
            id
          }
        }
      }
    }
  }
`);
